module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-height-100"
  }, [_c('Geo', {
    ref: "geo",
    attrs: {
      "map-data": _vm.collisionLocations,
      "marker-click-action": 'collisionsView/collision/fetch',
      "map-active": _vm.mapActive
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cd9c5c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/collisions/CollisionMap.vue
// module id = 440
// module chunks = 1